import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Grid, Modal, SvgIcon, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { CSSProperties, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import PageLeaveConfirmModal from 'src/components/common-modals/page-leave-confirmation';
import loader from 'src/components/LoaderImg/loader.gif';
import ReForm from 'src/components/reform';
import SucessModal from 'src/components/sucess-modal';
import {
  baseApiUrl,
  reFormsOtEvalTreatment,
  reFormsOtProgressNoteTreatment,
  reFormsPtEvalTreatment,
  reFormsPtProgressNoteTreatment,
  reFormsSlpEvalTreatment,
  reFormsSlpProgressNoteTreatment,
  reFormsOtRecertTreatment,
  reFormsPtRecertTreatment,
  reFormsSlpRecertTreatment,
  reFormsOtDischargeTreatment,
  reFormsPtDischargeTreatment,
  reFormsSlpDischargeTreatment,
} from 'src/config';
import useCurrentUser from 'src/hooks/use-current-user';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import {
  checkIsReformAction,
  errorForLoaderDocumentation,
  getAllCodesAction,
  getAllICDAction,
  getPrefillStartOfCareDate,
  getPrefillUrlAction,
  pullUuidAction,
  requestForLoaderDocumentation,
  resetForLoaderDocumentation,
  resetStartOfCareDate,
  resetUuidAction,
  successForLoaderDocumentation,
} from 'src/redux/actions/documentationAction';
import { getSinglePatient } from 'src/redux/actions/patientAction';
import { getAccessToken } from 'src/routes/AuthContext';
import { subscribeSubmissionevent } from 'src/services/apiServices/constants';
import { checkSupervisorPermission } from 'src/utils/checkSignatureAccess';
import { getSelectedFacilityName } from 'src/utils/get-selected-facility-name';
import { getTherapistCred } from 'src/utils/get-therapist-credential';
import { viewFormByFormID } from 'src/utils/jotform-functions';

type Props = {};

const loaderCSS: CSSProperties = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  userSelect: 'none',
  zIndex: 9999,
};

function TherapistDashboardDocEdit(props: Props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  // const { document } = location?.state || {};
  const document = useSelector(
    (state: any) => state.dashboardCreateEditDocumentDataReducer.document
  );
  const [generatePrefillUrl, setGeneratePrefillUrl] = useState('');
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const checkpatientLoading = useSelector((state: any) => state?.getSinglePatientReducer?.loading);
  const [buildTemplate, setBuildTemplate] = useState('');
  const submissionSse = useRef<EventSource | null>(null);
  const [openConfirmationModel, setOpenConfirmationModel] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const [providerId, discipline, licenseNumber, getCredentials, currentRoles, firstName, lastName] =
    useCurrentUser([
      'providerId',
      'discipline',
      'licenseNumber',
      'discipline',
      'currentRoles',
      'firstName',
      'lastName',
    ]);
  const getAllCodesResponse = useSelector((state: any) => state.getAllCodeReducers);
  const getSignatureAccess = useSelector((state: any) => state.getSignatureAccessReducer);
  const getAllICDCodesResponse = useSelector((state: any) => state.getAllICDCodeReducers);
  const pullUuidResponse = useSelector((state: any) => state.pullUuidRducder);
  const isDocLoader = useSelector((state: any) => state.loaderDocumenattionReducer);
  const getPrefillUrl = useSelector((state: any) => state.getPrefillUrlReducer);
  const getStartOfCareDate = useSelector((state: any) => state.getStartOfCareDateReducer?.response);

  const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);
  const [iframeRef, setIframeRef] = useState<any | null>(null);
  const allFacilities = useSelector(
    (state: any) => state?.getFacilityDropDownReducer?.response?.data?.data
  );

  useEffect(() => {
    if (!initialized) {
      dispatch(resetUuidAction());
      setInitialized(true);
    }
  }, [initialized, dispatch]);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  const [isReformDoc, setIsReformDoc] = useState<boolean>(false);
  const [notCallAgain, setNotCallAgain] = useState(false);
  const [notCallAgainNote, setNotCallAgainNote] = useState(false);

  const [reFormsPtEvalEnabled] = useFeatureToggleWhenReady(reFormsPtEvalTreatment, 'FACILITY');
  const [reFormsOtEvalEnabled] = useFeatureToggleWhenReady(reFormsOtEvalTreatment, 'FACILITY');
  const [reFormsSlpEvalEnabled] = useFeatureToggleWhenReady(reFormsSlpEvalTreatment, 'FACILITY');
  const [reFormsPtProgressNoteEnabled] = useFeatureToggleWhenReady(
    reFormsPtProgressNoteTreatment,
    'FACILITY'
  );
  const [reFormsOtProgressNoteEnabled] = useFeatureToggleWhenReady(
    reFormsOtProgressNoteTreatment,
    'FACILITY'
  );
  const [reFormsSlpProgressNoteEnabled] = useFeatureToggleWhenReady(
    reFormsSlpProgressNoteTreatment,
    'FACILITY'
  );

  const [reFormsOtRecertEnabled] = useFeatureToggleWhenReady(reFormsOtRecertTreatment, 'FACILITY');
  const [reFormsPtRecertEnabled] = useFeatureToggleWhenReady(reFormsPtRecertTreatment, 'FACILITY');
  const [reFormsSlpRecertEnabled] = useFeatureToggleWhenReady(
    reFormsSlpRecertTreatment,
    'FACILITY'
  );
  const [reFormsOtDischargeEnabled] = useFeatureToggleWhenReady(
    reFormsOtDischargeTreatment,
    'FACILITY'
  );
  const [reFormsPtDischargeEnabled] = useFeatureToggleWhenReady(
    reFormsPtDischargeTreatment,
    'FACILITY'
  );
  const [reFormsSlpDischargeEnabled] = useFeatureToggleWhenReady(
    reFormsSlpDischargeTreatment,
    'FACILITY'
  );

  const isReformsEnabled = () => {
    if (!pullUuidResponse?.response || !document.reformId) {
      return false;
    }

    if (reFormsPtEvalEnabled && document.formType === 'EVALUATION_REFORM_PT') {
      return true;
    }

    if (reFormsOtEvalEnabled && document.formType === 'EVALUATION_REFORM_OT') {
      return true;
    }

    if (reFormsSlpEvalEnabled && document.formType === 'EVALUATION_REFORM_SLP') {
      return true;
    }

    if (reFormsPtProgressNoteEnabled && document.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_PT') {
      return true;
    }

    if (reFormsOtProgressNoteEnabled && document.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_OT') {
      return true;
    }

    if (reFormsSlpProgressNoteEnabled && document.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_SLP') {
      return true;
    }

    if (document.formType === 'DAILY_SOAP_NOTE_REFORM') {
      return true;
    }

    if (reFormsOtRecertEnabled && document.formType === 'RECERTIFICATION_REFORM_OT') {
      return true;
    }

    if (reFormsPtRecertEnabled && document.formType === 'RECERTIFICATION_REFORM_PT') {
      return true;
    }

    if (reFormsSlpRecertEnabled && document.formType === 'RECERTIFICATION_REFORM_SLP') {
      return true;
    }
    if (reFormsOtDischargeEnabled && document.formType === 'DISCHARGE_REFORM_OT') {
      return true;
    }
    if (reFormsPtDischargeEnabled && document.formType === 'DISCHARGE_REFORM_PT') {
      return true;
    }
    if (reFormsSlpDischargeEnabled && document.formType === 'DISCHARGE_REFORM_SLP') {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (!document) return;
    setIsReformDoc(document?.formType?.includes('REFORM'));
    dispatch(checkIsReformAction(document?.formType?.includes('REFORM')));
  }, [document]);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  const getHiddenUuid = (pullUuidResponse: any) => {
    return `${pullUuidResponse.response?.trim()}X${
      window.location.hostname === 'localhost'
        ? localStorage.getItem('realm')
        : window.location.hostname.split('-')[0]
    }`;
  };

  const getCleanUuid = () => {
    return pullUuidResponse?.response?.trim() || '';
  };

  const backToEOCDetails = () => {
    navigate('/dashboard');
  };

  const handleBackConfirmation = (confirm: boolean) => {
    if (confirm) {
      backToEOCDetails();
    }
    setOpenConfirmationModel(false);
  };

  const goBack = () => {
    if (isReformDoc) {
      return backToEOCDetails();
    }
    setOpenConfirmationModel(true);
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (!isReformDoc) {
        const confirmationMessage =
          'You have unsaved changes. If you leave this page before submitting, your progress will be lost. Are you sure you want to continue?';
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isReformDoc]);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (!isReformDoc) {
        event.preventDefault();
        setOpenConfirmationModel(true);
        window.history.pushState(null, '', window.location.href);
      }
    };

    if (!isReformDoc) {
      window.history.pushState(null, '', window.location.href);
    }
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isReformDoc]);

  useEffect(() => {
    if (notCallAgainNote) return;
    if (!document || !pullUuidResponse.response) return;
    if (document?.submissionId) {
      setGeneratePrefillUrl(
        `${document?.prefillUrl}?hiddenUuid=${getHiddenUuid(pullUuidResponse)}${
          checkRecertiOrEval(document?.formType)
            ? `&payerName=${
                document?.payerName
                  ?.split('_')
                  ?.map(
                    (item: string) => item.slice(0, 1) + item.slice(1, item.length).toLowerCase()
                  )
                  ?.join(' ') || ''
              }`
            : `&payerName=`
        }`
      );
      setNotCallAgainNote(true);
    } else {
      dispatch(
        getSinglePatient({
          patientId: document?.patientId,
        })
      );
    }
  }, [document, pullUuidResponse]);
  useEffect(() => {
    if (!document || document.submissionId) return;
    if (
      !document.formType?.includes('PROGRESS') &&
      !document.formType?.includes('RECERTIFICATION') &&
      !document.formType?.includes('DISCHARGE')
    ) {
      return;
    }

    dispatch(
      getPrefillUrlAction(document.formId, {
        patientId: document?.patientId,
        type: discipline,
      })
    );
  }, [document]);

  useEffect(() => {
    if (!document) return;

    if (
      document?.formType === 'DAILY_SOAP_NOTE' ||
      document?.formType === 'DAILY_SOAP_NOTE_REFORM'
    ) {
      dispatch(
        pullUuidAction({
          notesId: document?.dailySessionNoteUuid,
          entityType: 'SOAP',
          formId: document?.formId,
        })
      );
    } else {
      let fetchMostRecent = false;

      if (
        reFormsPtEvalEnabled === null ||
        reFormsOtEvalEnabled === null ||
        reFormsSlpEvalEnabled === null ||
        reFormsPtProgressNoteEnabled === null ||
        reFormsOtProgressNoteEnabled === null ||
        reFormsSlpProgressNoteEnabled === null ||
        reFormsOtRecertEnabled === null ||
        reFormsPtRecertEnabled === null ||
        reFormsSlpRecertEnabled === null ||
        reFormsOtDischargeEnabled === null ||
        reFormsPtDischargeEnabled === null ||
        reFormsSlpDischargeEnabled === null
      ) {
        return;
      }

      if (document.reformId) {
        if (reFormsPtEvalEnabled && document.formType === 'EVALUATION_REFORM_PT') {
          fetchMostRecent = true;
        }

        if (reFormsOtEvalEnabled && document.formType === 'EVALUATION_REFORM_OT') {
          fetchMostRecent = true;
        }

        if (reFormsSlpEvalEnabled && document.formType === 'EVALUATION_REFORM_SLP') {
          fetchMostRecent = true;
        }

        if (
          reFormsPtProgressNoteEnabled &&
          document.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_PT'
        ) {
          fetchMostRecent = true;
        }

        if (
          reFormsOtProgressNoteEnabled &&
          document.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_OT'
        ) {
          fetchMostRecent = true;
        }

        if (
          reFormsSlpProgressNoteEnabled &&
          document.formType === 'WEEKLY_PROGRESS_NOTE_REFORM_SLP'
        ) {
          fetchMostRecent = true;
        }

        if (document.formType === 'DAILY_SOAP_NOTE_REFORM') {
          fetchMostRecent = true;
        }

        if (reFormsOtRecertEnabled && document.formType === 'RECERTIFICATION_REFORM_OT') {
          fetchMostRecent = true;
        }

        if (reFormsPtRecertEnabled && document.formType === 'RECERTIFICATION_REFORM_PT') {
          fetchMostRecent = true;
        }

        if (reFormsSlpRecertEnabled && document.formType === 'RECERTIFICATION_REFORM_SLP') {
          fetchMostRecent = true;
        }

        if (reFormsOtDischargeEnabled && document.formType === 'DISCHARGE_REFORM_OT') {
          fetchMostRecent = true;
        }

        if (reFormsPtDischargeEnabled && document.formType === 'DISCHARGE_REFORM_PT') {
          fetchMostRecent = true;
        }

        if (reFormsSlpDischargeEnabled && document.formType === 'DISCHARGE_REFORM_SLP') {
          fetchMostRecent = true;
        }
      }

      dispatch(
        pullUuidAction(
          {
            uuid: document?.submissionId ? document.uuid : null,
            providerId,
            formId: document?.formId,
            notesId:
              document?.formType === 'DAILY_SOAP_NOTE' ||
              document?.formType === 'DAILY_SOAP_NOTE_REFORM'
                ? document.uuid
                : null,
            episodeOfCareId: document?.episodeOfCareId,
            type: discipline,
            isForSupervisor: checkSupervisorPermission(
              getSignatureAccess.response?.data?.t1,
              document?.formType
            ),
            entityType: 'EOC',
            documentType: document?.formType,
            fromRequired: document.submissionId ? false : true,
          },
          {
            fetchMostRecent,
          }
        )
      );
    }
  }, [
    document,
    reFormsPtEvalEnabled,
    reFormsOtEvalEnabled,
    reFormsSlpEvalEnabled,
    reFormsPtProgressNoteEnabled,
    reFormsOtProgressNoteEnabled,
    reFormsSlpProgressNoteEnabled,
    reFormsOtRecertEnabled,
    reFormsPtRecertEnabled,
    reFormsSlpRecertEnabled,
    reFormsOtDischargeEnabled,
    reFormsPtDischargeEnabled,
    reFormsSlpDischargeEnabled,
  ]);

  useEffect(() => {
    if (!patientData) return;
    dispatch(
      getAllCodesAction(
        {
          discipline,
          type: 'cpt',
          eocUuid: document?.episodeOfCareId,
        },
        patientData?.uuid
      )
    );
    dispatch(
      getAllICDAction(
        {
          discipline,
          type: 'icd',
          eocUuid: document?.episodeOfCareId,
        },
        patientData?.uuid
      )
    );
  }, [patientData]);

  const closeErrorModal = () => {
    setOpenErrorModal(false);
    dispatch(resetForLoaderDocumentation());
  };

  const checkRecertiOrEval = (formType: string) => {
    if (formType?.includes('RECERTIFICATION') || formType?.includes('EVALUATION')) {
      return true;
    }
    return false;
  };

  function checkIsRectification(str: any) {
    if (str?.includes('RECERTIFICATION') || str?.includes('PROGRESS')) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    dispatch(resetStartOfCareDate());
    if (checkIsRectification(document.formType) && !!document.episodeOfCareId) {
      dispatch(
        getPrefillStartOfCareDate({
          submissionId: document.episodeOfCareId,
          param: {
            fromDashboard: true,
            discipline,
          },
        })
      );
    }
  }, [document]);

  const prefillDateValue = (prefillData: any, prefillKey: string) => {
    return `${
      prefillData
        ? `&${prefillKey}&${prefillKey}[month]=${prefillData?.split('-')[1]}&${prefillKey}[day]=${
            prefillData.split('-')[2].split('T')[0]
          }&${prefillKey}[year]=${prefillData?.split(
            '-'
          )[0]}&${prefillKey}[datetime]=${prefillData?.split('T')[0]}`
        : ''
    }`;
  };
  useEffect(() => {
    if (notCallAgain) return;
    if (
      !document ||
      document.submissionId ||
      getAllCodesResponse.response === null ||
      getAllICDCodesResponse.response === null ||
      !pullUuidResponse.response
    ) {
      return;
    }
    if (
      (document.formType?.includes('PROGRESS') ||
        document.formType?.includes('RECERTIFICATION') ||
        document.formType?.includes('DISCHARGE')) &&
      !getPrefillUrl.response?.data
    ) {
      return;
    }

    if (checkIsRectification(document.formType) && !getStartOfCareDate?.length) {
      return;
    }
    let urlData: string = getPrefillUrl.response?.data || '';
    switch (document?.formType) {
      case 'DAILY_PROGRESS_NOTE':
      case 'ADDENDUM_NOTE':
        setBuildTemplate(
          `${viewFormByFormID(
            document?.formId,
            urlData
          )}?patientName[first]=${patientData?.firstName}&patientName[last]=${patientData?.lastName}&hiddenUuid=${getHiddenUuid(
            pullUuidResponse
          )}`
        );
        setNotCallAgain(true);
        break;
      case 'DISCHARGE_SLP':
      case 'DISCHARGE_OT':
      case 'DISCHARGE_PT':
      case 'EVALUATION_PT':
      case 'EVALUATION_REFORM_PT':
      case 'EVALUATION_OT':
      case 'EVALUATION_REFORM_OT':
      case 'EVALUATION_SLP':
      case 'RECERTIFICATION_SLP':
      case 'RECERTIFICATION_OT':
      case 'RECERTIFICATION_PT':
      case 'WEEKLY_PROGRESS_NOTE_SLP':
      case 'WEEKLY_PROGRESS_NOTE_OT':
      case 'WEEKLY_PROGRESS_NOTE_PT':
      case 'TRANSITIONAL_EVALUATION_OT':
      case 'TRANSITIONAL_EVALUATION_PT':
      case 'TRANSITIONAL_EVALUATION_SLP':
        setBuildTemplate(
          `${viewFormByFormID(
            document?.formId,
            urlData
          )}?patientName[first]=${patientData?.firstName}&patientName[last]=${patientData?.lastName}&mrn=${
            patientData?.medicalRecordNumber || ''
          }&physicianName[first]=${
            patientData?.physicianEntitySet && patientData?.physicianEntitySet?.length !== 0
              ? patientData?.physicianEntitySet[0]?.physicianName?.split(' ')[0]
              : ''
          }&physicianName[last]=${
            patientData?.physicianEntitySet && patientData?.physicianEntitySet?.length !== 0
              ? patientData?.physicianEntitySet[0]?.physicianName
                  ?.split(' ')
                  .slice(1, patientData?.physicianEntitySet[0]?.physicianName?.length)
                  ?.join(' ')
              : ''
          }
          ${
            patientData?.dateOfBirth
              ? `&dateOfBirth&dateOfBirth[month]=${patientData?.dateOfBirth?.split(
                  '-'
                )[1]}&dateOfBirth[day]=${patientData?.dateOfBirth
                  .split('-')[2]
                  .split('T')[0]}&dateOfBirth[year]=${
                  patientData.dateOfBirth.split('-')[0]
                }&dateOfBirth[datetime]=${patientData?.dateOfBirth?.split('T')[0]}`
              : ''
          }
          ${
            getAllCodesResponse.response?.data?.cptCodes &&
            getAllCodesResponse.response?.data?.cptCodes?.length !== 0 &&
            ` &cptCodes=${getAllCodesResponse.response?.data?.cptCodes
              ?.map((item: string) => item.trim())
              ?.join(',')}`
          }
          ${
            getAllCodesResponse.response?.data?.cptCodes &&
            getAllCodesResponse.response?.data?.cptCodes?.length !== 0 &&
            `&CodesCPT=${
              getAllCodesResponse.response?.data?.cptCodes
                ?.map((item: string) => item.trim())
                ?.join(',') + ','
            }`
          }
          ${
            getAllICDCodesResponse.response?.data &&
            getAllICDCodesResponse.response?.data?.Medical?.length !== 0 &&
            `&ICD10TMedicalCodes=${getAllICDCodesResponse.response?.data?.Medical?.map(
              (item: string) => item.trim()
            ).join('%0A')}`
          }
          ${
            getAllICDCodesResponse.response?.data &&
            getAllICDCodesResponse.response?.data?.Treatment?.length !== 0 &&
            `&ICD10TreatmentCodes=${getAllICDCodesResponse.response?.data?.Treatment?.map(
              (item: string) => item
            )?.join('%0A')}`
          }
          &icd10Codes=${
            getAllICDCodesResponse.response?.data?.Medical?.map((item: string) => item.trim()).join(
              ','
            ) +
            getAllICDCodesResponse.response?.data?.Treatment?.map((item: string) =>
              item.trim()
            )?.join(',')
          }
          &hiddenUuid=${getHiddenUuid(pullUuidResponse)}&licenseNumber=${
            licenseNumber || ''
          }&text20=${licenseNumber || ''}&therapistName=${
            user?.firstName + ' ' + user?.lastName
          }&text10=${user?.firstName + ' ' + user?.lastName}${
            checkIsRectification(document?.formType) &&
            !!getStartOfCareDate?.length &&
            prefillDateValue(getStartOfCareDate[0], 'startOf')
          }${
            checkRecertiOrEval(document?.formType)
              ? `&payerName=${
                  document?.payerName
                    ?.split('_')
                    ?.map(
                      (item: string) => item.slice(0, 1) + item.slice(1, item.length).toLowerCase()
                    )
                    ?.join(' ') || ''
                }`
              : `&payerName=`
          }&credentials=${
            getCredentials || getTherapistCred(discipline, currentRoles)
          }&siteOfService=${getSelectedFacilityName(
            allFacilities
          )}&siteOf=${getSelectedFacilityName(allFacilities)}&fullTherapistName[first]=${
            firstName || ''
          }&fullTherapistName[last]=${lastName || ''}`
        );
        setNotCallAgain(true);
        break;
      default:
        setBuildTemplate(viewFormByFormID(document?.formId, urlData));
        setNotCallAgain(true);
    }
  }, [
    document,
    getAllCodesResponse,
    getAllICDCodesResponse,
    pullUuidResponse,
    getPrefillUrl,
    getStartOfCareDate,
  ]);

  useEffect(() => {
    if (!pullUuidResponse.response || !document) return;

    const createEventSource = () => {
      submissionSse.current = new EventSource(
        `${baseApiUrl}${subscribeSubmissionevent}/${pullUuidResponse.response}`
      );

      submissionSse.current.addEventListener('message', (e) => {
        const eventData = JSON.parse(e.data);
        switch (eventData?.data) {
          case '1':
            dispatch(requestForLoaderDocumentation(eventData?.data));
            break;
          case '2':
            navigate('/dashboard');
            dispatch(successForLoaderDocumentation(eventData?.data));
            break;
          case '3':
            dispatch(errorForLoaderDocumentation(eventData?.error));
            break;
          default:
            break;
        }
      });

      submissionSse.current.addEventListener('error', (e: any) => {
        if (e.eventPhase === 2) {
          if (submissionSse.current) {
            submissionSse.current.close();
          }
          createEventSource();
        }
      });

      return () => {
        if (submissionSse.current) {
          submissionSse.current.close();
        }
      };
    };

    createEventSource();

    return () => {
      if (submissionSse.current) {
        submissionSse.current.close();
      }
    };
  }, [document, pullUuidResponse]);

  useEffect(() => {
    if (!isDocLoader.loader && isDocLoader.response === null) return;
    if (isDocLoader.error) {
      setOpenErrorModal(true);
      return;
    }
    if (!isDocLoader.loader) {
      dispatch(resetForLoaderDocumentation());
    }
  }, [isDocLoader]);

  return (
    <>
      {isDocLoader.loader && (
        <Grid sx={loaderCSS}>
          <img
            src={loader}
            alt="loader.."
          />
        </Grid>
      )}

      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          onClick={goBack}
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
        >
          {/* <Link
            style={{ color: '#111927' }}
            to={'/dashboard'}
          > */}
          <Typography variant="subtitle1">Back to Dashboard</Typography>
          {/* </Link> */}
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5">{`${
            document?.submissionId ? 'Edit Document' : 'Create Document'
          } - ${document.documentType}`}</Typography>
        </Stack>
      </Stack>
      <Box
        sx={{ height: '100%' }}
        p={3}
      >
        {document?.submissionId ? (
          <Box
            sx={{ height: '100%' }}
            p={3}
          >
            {isReformsEnabled() ? (
              <Box
                style={
                  document?.formType === 'DAILY_SOAP_NOTE_REFORM'
                    ? undefined
                    : { maxHeight: '70vh', overflow: 'auto' }
                }
              >
                <ReForm
                  uuid={getCleanUuid()}
                  formId={document?.reformId}
                />
              </Box>
            ) : (
              generatePrefillUrl && (
                <iframe
                  src={generatePrefillUrl}
                  ref={updateIFrameRef}
                  width={'100%'}
                  height={'100%'}
                  style={{ border: 'none' }}
                  title="document-prefill"
                />
              )
            )}
          </Box>
        ) : (
          <>
            {checkpatientLoading.isLoading ? (
              <img
                src={loader}
                alt="loader"
                style={{ width: '10%', margin: 'auto', display: 'block', marginTop: '10%' }}
              />
            ) : (
              <Box
                sx={{ height: '100%' }}
                p={3}
              >
                {isReformsEnabled() ? (
                  <Box
                    style={
                      document?.formType === 'DAILY_SOAP_NOTE_REFORM'
                        ? undefined
                        : { maxHeight: '70vh', overflow: 'auto' }
                    }
                  >
                    <ReForm
                      uuid={getCleanUuid()}
                      formId={document?.reformId}
                    />
                  </Box>
                ) : (
                  buildTemplate && (
                    <iframe
                      src={buildTemplate}
                      ref={updateIFrameRef}
                      width={'100%'}
                      height={'100%'}
                      style={{ border: 'none' }}
                      title="create-document"
                    />
                  )
                )}
              </Box>
            )}
          </>
        )}

        <BootstrapDialog
          onClose={() => setOpenConfirmationModel(false)}
          aria-labelledby="customized-dialog-title"
          open={openConfirmationModel}
          PaperProps={{ style: { maxWidth: '750px' } }}
        >
          <PageLeaveConfirmModal
            close={() => setOpenConfirmationModel(false)}
            handleSaveBtn={() => handleBackConfirmation(true)}
          />
        </BootstrapDialog>

        <Modal open={openErrorModal}>
          <SucessModal
            close={closeErrorModal}
            isSucess={false}
            title="Edit a Document"
            message={isDocLoader.response}
          />
        </Modal>
      </Box>
    </>
  );
}

export default TherapistDashboardDocEdit;
